var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"no-gutters":""}},[_c('base-header-bar'),_c('v-col',{staticClass:"text-center mt-15",attrs:{"cols":"12"}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }